import { TransactionGroup } from 'components/order-details/transactions';
import { Order, OrderLineItem } from 'components/pages/order-details';
import { PreviewLineItems } from 'hooks/postRegEditDrawer';

export enum LoadingType {
  GetOrder,
  GetOverview,
  GetTransactions,
  GetPaymentSchedule,
  GetNotes,
  CancelFees,
  RefundTransaction,
  GetInstallments,
  UpdateInstallment,
  CreateOfflinePayment,
  GetPreviewLineItems,
  SaveAdjustment,
}
export type Note = {
  id: number;
  body: string;
  insertedAt: string;
  updatedAt: string;
  orderId: number;
  createdByName: string;
  sourceType: string;
  sourceId: number;
  isSystemGenerated: boolean;
  createdByUserId: number;
};

export type Refund = {
  id: number;
  amount: number;
  status: string;
  paymentId: number;
};

export type Installment = {
  amount: number;
  feeAmount: number;
  id: number;
  paidAt: string;
  paymentMethod: {
    accountName: string;
    accountType: string;
    last_4: string;
  };
  scheduledDate: string;
  status: string;
  transactionId: number;
};

export interface OrderDetailsState {
  loading: Record<LoadingType, boolean>;
  order: Order;
  orgId: number;
  orderLineItems: OrderLineItem[];
  transactions: TransactionGroup[];
  installments: Installment[];
  notes: Note[];
  previewLineItems: PreviewLineItems;
  error?: string;
}

export enum ActionType {
  SetLoading,
  SetError,
  SetOrder,
  SetOrgId,
  SetNotes,
  SetTransactions,
  SetInstallments,
  SetPreviewLineItems,
}

export type SetErrorPayload = {
  error: string;
};

export type SetOrderPayload = {
  order: Order;
};

export type SetOrgIdPayload = {
  orgId: number;
};

export type SetNotesPayload = {
  notes: Note[];
};

export type SetTransactionsPayload = {
  transactions: TransactionGroup[];
};

export type SetInstallmentsPayload = {
  installments: Installment[];
};

export type SetPreviewLineItemsPayload = {
  previewLineItems: PreviewLineItems;
};
